exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-orange {\n    color: #ef871d;\n}\n", ""]);

// exports
